// Utils
import { string, attr } from 'fc-decoders'
import _uniqueId from 'lodash/uniqueId'

// Constants
import {
  PROP_ID,
  PROP_LABEL,
  PROP_GEOJSON,
  PROP_COMMENTS,
  PROP_OPTIONS,
} from '../constants'

// Exports
export default {
  [PROP_ID]: function (id) {
    return id ? `${id}` : _uniqueId()
  },
  [PROP_LABEL]: string,
  [PROP_GEOJSON]: attr(),
  [PROP_COMMENTS]: string,
  [PROP_OPTIONS]: attr('object'),
}
